/**
 * @generated SignedSource<<426bea05067adca6d22be0664fa13db3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useGetPackageNeedingAttention_customer$data = {
  readonly activePackages: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly orders: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly " $fragmentSpreads": FragmentRefs<"packageOrderNeedsPayment_order">;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly package: {
          readonly __typename: string;
        };
        readonly " $fragmentSpreads": FragmentRefs<"packageMissingPaymentMethod_memberPackage" | "packagePaymentMethodExpired_memberPackage">;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly upcomingPackages: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly package: {
          readonly __typename: string;
        };
        readonly " $fragmentSpreads": FragmentRefs<"packageMissingPaymentMethod_memberPackage" | "packagePaymentMethodExpired_memberPackage">;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "useGetPackageNeedingAttention_customer";
};
export type useGetPackageNeedingAttention_customer$key = {
  readonly " $data"?: useGetPackageNeedingAttention_customer$data;
  readonly " $fragmentSpreads": FragmentRefs<"useGetPackageNeedingAttention_customer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "package",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "packageDueDate",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "package",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "billingType",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "kind": "InlineDataFragmentSpread",
  "name": "packageMissingPaymentMethod_memberPackage",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SquareCardOnFile",
      "kind": "LinkedField",
      "name": "squareCard",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    (v3/*: any*/)
  ],
  "args": null,
  "argumentDefinitions": ([]/*: any*/)
},
v5 = {
  "kind": "InlineDataFragmentSpread",
  "name": "packagePaymentMethodExpired_memberPackage",
  "selections": [
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "OrderConnection",
      "kind": "LinkedField",
      "name": "orders",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "OrderEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Order",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v2/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SquareCardOnFile",
      "kind": "LinkedField",
      "name": "squareCard",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "expMonth",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "expYear",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "args": null,
  "argumentDefinitions": ([]/*: any*/)
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useGetPackageNeedingAttention_customer",
  "selections": [
    {
      "alias": "activePackages",
      "args": [
        {
          "kind": "Literal",
          "name": "status",
          "value": "ACTIVE"
        }
      ],
      "concreteType": "MemberPackageConnection",
      "kind": "LinkedField",
      "name": "memberPackages",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "MemberPackageEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "MemberPackage",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "OrderConnection",
                  "kind": "LinkedField",
                  "name": "orders",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "OrderEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Order",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "InlineDataFragmentSpread",
                              "name": "packageOrderNeedsPayment_order",
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "status",
                                  "storageKey": null
                                },
                                (v2/*: any*/)
                              ],
                              "args": null,
                              "argumentDefinitions": []
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                (v4/*: any*/),
                (v5/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "memberPackages(status:\"ACTIVE\")"
    },
    {
      "alias": "upcomingPackages",
      "args": [
        {
          "kind": "Literal",
          "name": "status",
          "value": "UPCOMING"
        }
      ],
      "concreteType": "MemberPackageConnection",
      "kind": "LinkedField",
      "name": "memberPackages",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "MemberPackageEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "MemberPackage",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                (v0/*: any*/),
                (v4/*: any*/),
                (v5/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "memberPackages(status:\"UPCOMING\")"
    }
  ],
  "type": "Customer",
  "abstractKey": null
};
})();

(node as any).hash = "7bb58c0cd59949f84be71e92b863d2c3";

export default node;
